module.exports = __webpack_public_path__ + "media/application/images/ui/email-spacer-00c04aab63f1f4ed2f08723c499beddc.gif";